export default __webpack_public_path__ + "static/media/avatar2.d5bbfb77.png";